import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createPartnerRequest,
  getPartners,
  removePartner,
  updatePartnerRequest,
} from "../../../../services/api/landing/partners/partnersApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "Partner created successfully!",
    ar: "تم إنشاء الشريك بنجاح!",
  },
  addError: {
    en: "Failed to create partner.",
    ar: "فشل في إنشاء الشريك.",
  },
  update: {
    en: "Partner updated successfully!",
    ar: "تم تحديث الشريك بنجاح!",
  },
  updateError: {
    en: "Failed to update partner.",
    ar: "فشل في تحديث الشريك.",
  },
  delete: {
    en: "Partner deleted successfully!",
    ar: "تم حذف الشريك بنجاح!",
  },
  deleteError: {
    en: "Failed to delete partner.",
    ar: "فشل في حذف الشريك.",
  },
};

export const fetchPartners = createAsyncThunk(
  "partners/fetchPartners",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPartners();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch partners");
    }
  },
);

export const createPartner = createAsyncThunk(
  "partners/createPartner",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createPartnerRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create partner");
    }
  },
);

export const updatePartner = createAsyncThunk(
  "partners/updatePartner",
  async ({ partnerId, formData }, { rejectWithValue }) => {
    try {
      const response = await updatePartnerRequest(partnerId, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update partner");
    }
  },
);

export const deletePartner = createAsyncThunk(
  "partners/deletePartner",
  async (partnerId, { rejectWithValue }) => {
    try {
      await removePartner(partnerId);
      return partnerId;
    } catch (error) {
      return rejectWithValue("Failed to delete partner");
    }
  },
);

const partnersSlice = createSlice({
  name: "partners",
  initialState: {
    partnerData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partnerData = action.payload;
      })
      .addCase(fetchPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createPartner.fulfilled, (state, action) => {
        state.partnerData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createPartner.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updatePartner.fulfilled, (state, action) => {
        const index = state.partnerData.findIndex(
          (partner) => partner.id === action.payload.id,
        );
        if (index !== -1) {
          state.partnerData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updatePartner.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deletePartner.fulfilled, (state, action) => {
        state.partnerData = state.partnerData.filter(
          (partner) => partner.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deletePartner.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default partnersSlice.reducer;
